'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { formatShares } from '@/lib/format/format-shares';
import { cn } from '@/lib/ui/utils';
interface ReceiveSharesRowProps {
  /** Exact D6 outcome-share count returned by the executable trade quote. */
  shareCountD6: bigint | null;
  /** Pre-formatted, display-currency effective execution price. */
  averagePriceLabel: string | null;
  /** Replaces the quote summary in-place while the form has a visible status. */
  statusMessage?: string | null;
  /** Accessible role used while a status message is visible. */
  statusRole?: 'alert' | 'status';
  /** Optional action rendered beside a status, such as retry. */
  statusAction?: React.ReactNode;
  /** Visual treatment for unavailable/error states. */
  statusTone?: 'neutral' | 'error';
}

/** Trade quote/status summary rendered directly below the amount input. */
export function ReceiveSharesRow(t0) {
  const $ = _c(17);
  const {
    shareCountD6,
    averagePriceLabel,
    statusMessage: t1,
    statusRole: t2,
    statusAction: t3,
    statusTone: t4
  } = t0;
  const statusMessage = t1 === undefined ? null : t1;
  const statusRole = t2 === undefined ? "status" : t2;
  const statusAction = t3 === undefined ? null : t3;
  const statusTone = t4 === undefined ? "neutral" : t4;
  const t = useTranslations("trade");
  let t5;
  if ($[0] !== averagePriceLabel || $[1] !== shareCountD6 || $[2] !== t) {
    t5 = shareCountD6 !== null && averagePriceLabel !== null ? t("receive_shares_avg_price", {
      count: formatShares(shareCountD6),
      price: averagePriceLabel
    }) : null;
    $[0] = averagePriceLabel;
    $[1] = shareCountD6;
    $[2] = t;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const valueText = t5;
  const t6 = statusMessage !== null && statusTone === "error" && "text-feedback-error-content";
  let t7;
  if ($[4] !== t6) {
    t7 = cn("flex min-h-5 items-center justify-center gap-2 text-caption text-foreground-tertiary", t6);
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== statusMessage || $[7] !== statusRole) {
    t8 = statusMessage !== null ? {
      role: statusRole,
      "aria-live": "polite"
    } : {};
    $[6] = statusMessage;
    $[7] = statusRole;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== statusAction || $[10] !== statusMessage || $[11] !== valueText) {
    t9 = statusMessage !== null ? <><span className={cn(statusAction === null && "w-full text-center")}>{statusMessage}</span>{statusAction}</> : valueText !== null && <span className="tabular-nums">{valueText}</span>;
    $[9] = statusAction;
    $[10] = statusMessage;
    $[11] = valueText;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <div className={t7} data-testid="receive-shares-row" {...t8}>{t9}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}